import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form} from "react-bootstrap";
import { Container, Row, Col, Button} from "react-bootstrap";
import { useState } from "react";
import axios from "axios";

const PersonalDetails = () => {

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phno: "",
    linkedin_url: "",
    profile_pic: "",
    designation: "",
    password: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddUser = async () => {
    const { first_name, last_name, email, phno, linkedin_url, profile_pic, designation, password } = formData;

    if (!first_name || !last_name || !email || !phno || !linkedin_url || !profile_pic || !designation || !password) {
      alert("Please fill all fields.");
      return;
    }

    setLoading(true);
    setResponseMessage("");

    try {
      const response = await axios.post(
        "http://localhost/feb11th/add-user.php",
        new URLSearchParams(formData)
      );

      const { status, message } = response.data;

      if (status === "success") {
        alert("User added successfully!");
        setResponseMessage(message);
      } else {
        setResponseMessage(`Error: ${message}`);
      }
    } catch (error) {
      console.error("Error adding user:", error);
      setResponseMessage("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <h2 className="text-center fw-bold m-4">Personal details</h2>
      </div>
      <Container fluid className="d-flex justify-content-center align-items-center bg-light">
      <Container className="bg-white shadow-sm rounded p-4" style={{ maxWidth: "800px" }}>
        

        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>First name</Form.Label>
              <Form.Control placeholder="Enter first name" type='text' name='first_name' value={formData.first_name} onChange={handleInputChange} className="bg-light"/>
            </Col>
            <Col md={6}>
              <Form.Label>Last name</Form.Label>
              <Form.Control placeholder='Enter last name' type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} className="bg-light" />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>E-mail</Form.Label>
              <Form.Control placeholder='Enter email' type='email' name="email" value={formData.email} onChange={handleInputChange} className="bg-light" />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Password</Form.Label>
              <Form.Control placeholder='Enter password' type='password' name="password" value={formData.password} onChange={handleInputChange} className="bg-light" />
            
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Designation</Form.Label>
              <Form.Control placeholder='Enter job role' type='text' name='designation' value={formData.designation} onChange={handleInputChange} className="bg-light" />
            
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Linkedin</Form.Label>
              <Form.Control placeholder='Enter Linkedin profile Url' type='text' name="linkedin_url" value={formData.linkedin_url} onChange={handleInputChange} className="bg-light" />
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={6}>
            <Form.Label>Mobile number</Form.Label>
              <Form.Control placeholder='Enter mobile' type='text' name="phno" value={formData.phno} onChange={handleInputChange} className="bg-light" />
             
            </Col>
            <Col md={3} className="d-flex align-items-center">
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Profile Picture</Form.Label>
              <Form.Control placeholder='Enter profile Url' type='text' name="profile_pic" value={formData.profile_pic} onChange={handleInputChange} className="bg-light" />
            </Col>
          </Row>

          <div className="text-end">
            <Button variant="primary" className="px-4" onClick={handleAddUser} disabled={loading}>
            {loading ? "Adding..." : "Add User"}
            </Button>
            {responseMessage && <p>{responseMessage}</p>}
          </div>
        </Form>
      </Container>
    </Container>
    </div>
    
  )
}

export default PersonalDetails
